import React, {FC, ReactNode} from 'react'
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {useAuthInitSeparated} from "@containers/auth/hooks/useAuthInit";
import {useAuthContext} from "@containers/auth/context/hooks/useAuthContext";
import UserActiveAccess from "@containers/account/access/userAccess/UserActiveAccess";
import SignIng from "@containers/auth/signIn/SignIn";


interface IProps {
    children: ReactNode
}

const AuthSeparate: FC<IProps> = ({children}) => {


    const {isAuth} = useAuthContext()

    const {isLoading} = useAuthInitSeparated()

    if (isLoading) {
        return <SpinnerCustom variant={'absolute'}/>
    }

    if (!isAuth) {
        return <SignIng/>
    }


    return (
        <UserActiveAccess>
            {children}
        </UserActiveAccess>
    );
};

export default AuthSeparate;
